export const
    CURRENT = 0,
    RECOMMENDED = 1;